
export class Filter {

  property?: string;
  filterValue?: string;

  // When 'IN' or 'NOT_IN' filter type is used, filterValue needs to be a comma separated string of the values to filter for
  filterType?: 'MATCH'|'EQUAL'|'NOT_EQUAL'|'LESS'|'LESS_OR_EQUAL'|'GREATER'|'GREATER_OR_EQUAL'|'IS_NULL'|'IS_NOT_NULL'|'IN'|'NOT_IN' = 'MATCH';
  joinType?: 'INNER'|'LEFT'|'RIGHT' = 'INNER';
}
